import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useRef } from 'react';
import { Icon } from '@haldor/ui'; //    onClick={(event) => toggleList(event)}

var CustomSelector = function CustomSelector(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var ref = useRef(null);
  var buttonRef = useRef(null);

  var handleOutsideClick = function handleOutsideClick(event) {
    var _ref$current;

    if (ref !== null && ref !== void 0 && ref.current && !((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(event.target)) && event.path != null && event.path[0] !== buttonRef.current) {
      setOpen(false);
    }
  };

  useEffect(function () {
    document.addEventListener('click', handleOutsideClick, true);
    return function () {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  var buttonAction = function buttonAction(e) {
    e.preventDefault();

    if (!open) {
      props.fetchLesson();
    }

    setOpen(function (prev) {
      return !prev;
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "selectorForm"
  }, /*#__PURE__*/React.createElement("button", {
    ref: buttonRef,
    className: open ? 'c--button dropdown active' : 'c--button dropdown',
    onClick: function onClick(event) {
      return buttonAction(event);
    }
  }, props.label, /*#__PURE__*/React.createElement(Icon, {
    name: "Chevron_Down",
    style: {
      marginLeft: '2rem'
    }
  })), open ? /*#__PURE__*/React.createElement("div", {
    className: "selectorExpendable",
    ref: ref
  }, props.children) : null);
};

export default CustomSelector;